import seedLegalDocumentsJson from "./seedLegalDocuments.json";

export const seedLegalDocuments = seedLegalDocumentsJson;
